import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './HighlightedTile.module.css';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import IconSvg from '../widgets/Illustration/IconSvg';

export const HighlightedTile = ({ bgColor = 'eggshell02', titleGradient = 'passionFruit01', ...props }) => {
    const bgClassName = `bg${bgColor.charAt(0).toUpperCase() + bgColor.slice(1)}`;
    const variantClassName = props.variant ? styles[props.variant] : undefined;
    const shouldUseShadow = props.variant !== 'contentRow' && props.variant !== 'iconTile';

    const containerClassNames = clsx(styles.container, variantClassName, shouldUseShadow && styles.withShadow, bgClassName);

    const topBaseClasses = clsx(
        styles.topContainer,
        ['halfWidth', 'contentRow', 'iconTile'].includes(props.variant) ? styles.topVariant : styles.topDefault,
        props.titleH2 && styles.topTitleH2,
    );

    return (
        <div className={containerClassNames}>
            {props.icon && (
                <div className={topBaseClasses}>
                    <IconSvg img={props.icon} width={props.variant === 'iconTile' ? '60' : null} height={props.variant === 'iconTile' ? '60' : null} />
                </div>
            )}
            {props.title && (
                <div className={topBaseClasses}>
                    <PromoDangerouslyHtml
                        tag="div"
                        variant={props.titleH2 ? 'h2' : 'h4'}
                        color={props.color}
                        gradientColor={titleGradient}
                        dangerouslyHtml={props.title}
                    />
                </div>
            )}
            {props.text && props.variant === 'iconTile' && <PromoDangerouslyHtml tag="div" variant="subheader" color="gray80" dangerouslyHtml={props.text} />}
            {props.text && props.variant !== 'iconTile' && (
                <PromoDangerouslyHtml tag="div" color={props.promoDarkPage ? 'gray40' : 'gray80'} dangerouslyHtml={props.text} />
            )}
        </div>
    );
};

HighlightedTile.propTypes = {
    variant: PropTypes.oneOf(['plain', 'halfWidth', 'contentRow', 'iconTile']),
    bgColor: PropTypes.oneOf(['white', 'purple5', 'gray5', 'eggshell01', 'eggshell02', 'eggshell03', 'transparent', 'gray100']),
    color: PropTypes.oneOf(['baseColor', 'primary', 'primaryB2B', 'purple80', 'purple40', 'purple20', 'gray80', 'gray40', 'gray20', 'white']),
    titleGradient: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'aubergine04',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    icon: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
    titleH2: PropTypes.bool,
    promoDarkPage: PropTypes.bool,
};
